import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/institution/message/center',
    name: 'InstitutionMessageCenter',
    component: () => import('@/views/message/center'),
    meta: {
      title: i18n.t('router.message.message_center'),
      headType: 2,
      routerType: 2,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/institution/message.js